"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _cultureContext = require("./cultureContext");
Object.keys(_cultureContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _cultureContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cultureContext[key];
    }
  });
});
//# sourceMappingURL=index.js.map